import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Card, CardHeader, Col, Container, Row } from 'reactstrap';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import 'datatables.net-bs5';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Breadcrumbs, H4 } from '../../../AbstractElements';
import { MobileUsersTableHeader } from '../../../Constant';
import ManageMobileClients from '../../../api/ManageMobileClients';

const MobileUsers = () => {
    const tableRef = useRef(null);
    const [clients, setClients] = useState([]);
    const [loadingClientId, setLoadingClientId] = useState(null);

    const loadClients = () => {
        ManageMobileClients.loadClients()
            .then((response) => {
                const meta = response.data.response;
                if (meta.status_code === 200) {
                    setClients(response.data.data || []);
                } else {
                    toast.error(meta.message || "Erreur lors du chargement des utilisateurs.");
                }
            })
            .catch(() => {
                toast.error("Erreur lors du chargement des données. Réessayer plus tard.");
            });
    };

    const handleToggleBlock = async (clientId, blocked) => {
        setLoadingClientId(clientId);
        try {
            const response = await ManageMobileClients.blockTransactions({ client_id: clientId, blocked });
            const meta = response.data.response;
            if (meta.status_code === 200) {
                toast.success(blocked ? "Transactions bloquées avec succès" : "Transactions débloquées avec succès");
                const newBlocked = response.data.data?.transaction_blocked ?? blocked;
                setClients((prev) => prev.map((c) =>
                    c.client_id === clientId ? { ...c, transaction_blocked: newBlocked } : c
                ));
            } else {
                toast.error(meta.message || meta.error?.message || "Erreur lors de la mise à jour");
            }
        } catch (error) {
            toast.error("Erreur lors de la mise à jour");
        } finally {
            setLoadingClientId(null);
        }
    };

    useEffect(() => {
        const $table = $(tableRef.current);

        if (!$.fn.DataTable.isDataTable(tableRef.current)) {
            $table.DataTable({
                language: {
                    processing:     "Traitement en cours...",
                    search:         "Rechercher&nbsp;:",
                    lengthMenu:     "Afficher _MENU_ éléments",
                    info:           "Affichage de l'élément _START_ à _END_ sur _TOTAL_ éléments",
                    infoEmpty:      "Affichage de l'élément 0 à 0 sur 0 élément",
                    infoFiltered:   "(filtré de _MAX_ éléments au total)",
                    infoPostFix:    "",
                    loadingRecords: "Chargement en cours...",
                    zeroRecords:    "Aucun élément à afficher",
                    emptyTable:     "Aucune donnée disponible dans le tableau",
                    paginate: {
                        first:      "Premier",
                        previous:   "Précédent",
                        next:       "Suivant",
                        last:       "Dernier"
                    },
                    aria: {
                        sortAscending:  ": activer pour trier la colonne par ordre croissant",
                        sortDescending: ": activer pour trier la colonne par ordre décroissant"
                    }
                },
                data: [],
                columns: MobileUsersTableHeader.map((header) => ({ title: header })),
            });
        }

        loadClients();

        return () => {
            if ($.fn.DataTable.isDataTable(tableRef.current)) {
                $table.DataTable().destroy();
            }
        };
    }, []);

    useEffect(() => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            const table = $(tableRef.current).DataTable();
            table.clear();

            clients.forEach((client) => {
                const blocked = !!client.transaction_blocked;
                const isLoading = loadingClientId === client.client_id;

                table.row.add([
                    client.x_bet_identifier ?? '-',
                    client.complete_name ?? '',
                    client.phone_number ?? '',
                    blocked
                        ? '<span class="badge bg-danger">BLOQUÉES</span>'
                        : '<span class="badge bg-success">ACTIVES</span>',
                    `<button class='btn btn-sm ${blocked ? 'btn-success' : 'btn-danger'} toggle-btn'
                            data-id='${client.client_id}'
                            data-blocked='${!blocked}'
                            ${isLoading ? 'disabled' : ''}>
                        ${isLoading
                            ? "<span class='spinner-border spinner-border-sm'></span>"
                            : (blocked ? "<i class='fa fa-check'></i> Activer" : "<i class='fa fa-ban'></i> Désactiver")}
                     </button>`
                ]);
            });
            table.draw();

            $(tableRef.current).off('click', '.toggle-btn').on('click', '.toggle-btn', function () {
                const id = parseInt($(this).data('id'));
                const blocked = $(this).data('blocked') === true || $(this).data('blocked') === 'true';
                handleToggleBlock(id, blocked);
            });
        }
    }, [clients, loadingClientId]);

    return (
        <Fragment>
            <Breadcrumbs mainTitle="Gérer utilisateur mobile" parent="Gestion" title="Utilisateurs mobile" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <ToastContainer />
                        <Card>
                            <CardHeader>
                                <H4 attrH4={{ className: 'card-title mb-0' }}>Liste des utilisateurs mobile</H4>
                            </CardHeader>
                            <div className='table-responsive edit-table'>
                                <table
                                    ref={tableRef}
                                    className='display table table-striped table-vcenter text-nowrap'
                                    style={{ width: '100%' }}
                                >
                                    <thead>
                                    <tr>
                                        {MobileUsersTableHeader.map((header, i) => (
                                            <th key={i}>{header}</th>
                                        ))}
                                    </tr>
                                    </thead>
                                    <tbody></tbody>
                                </table>
                            </div>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default MobileUsers;
